<template>
  <v-container fill-height class="my-5">
    <v-layout>
      <v-flex xs12>
        <v-card>
          <v-card-title>
            <v-icon
              medium
              left>
              library_books
            </v-icon>
            <span class="title">Data Jenis Olahraga</span>
          </v-card-title>
          <v-tabs
            v-model="tabdata"
            :background-color="maincolor"
            centered
            dark
            icons-and-text
            show-arrows>
            <v-tabs-slider color="pink"></v-tabs-slider>
            <v-tab href="#tab-list">
              Jenis Olahraga
              <v-icon large>library_books</v-icon>
            </v-tab>
            <v-tab href="#tab-addnew">
              Buat Baru
              <v-icon large>library_add</v-icon>
            </v-tab>
          </v-tabs>
          <v-tabs-items :touchless="true" v-model="tabdata">
            <v-tab-item value="tab-list">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <v-row justify="center">
                      <v-col cols="12" md="12">
                        <v-text-field
                          v-model="filter.search"
                          append-icon="search"
                          label="Search"
                          single-line
                          hide-details>
                        </v-text-field>
                      </v-col>
                    </v-row>
                    <v-row>
                      <v-col cols="12">
                        <div class="text-center" v-if="loading.getdata">
                          <v-progress-circular
                            :width="3"
                            color="red"
                            indeterminate>
                          </v-progress-circular>
                        </div>
                        <v-data-table
                          v-if="!loading.getdata"
                          :headers="headers"
                          :items="datalist"
                          :search="filter.search">
                          <template v-slot:[`item.action`]="{ item }">
                            <v-btn
                              @click="editJenisolga(item)"
                              small
                              icon>
                              <v-icon>edit</v-icon>
                            </v-btn>
                          </template>
                        </v-data-table>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
            <v-tab-item value="tab-addnew">
              <v-card flat>
                <v-card-text>
                  <v-container>
                    <alertsp :alertdata="alertdata"></alertsp>
                    <v-form
                      @submit.prevent="submitAdd"
                      ref="formaddjenisolga"
                      v-model="formadd.valid"
                      lazy-validation>
                      <v-row justify="center" no-gutters>
                        <v-col cols="12" sm="8" md="6">
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addjenisolga.nama_olga"
                                :rules="[rules.required]"
                                label="Nama"
                                name="nama"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-text-field
                                v-model="addjenisolga.deskripsi_olga"
                                :rules="[rules.required]"
                                label="Deskripsi"
                                name="deskripsi"
                                required>
                              </v-text-field>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-select
                                :items="listfav"
                                name="favorite"
                                v-model="addjenisolga.favorite_olga"
                                label="Favorit"
                                :rules="[rules.required]">
                              </v-select>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-file-input
                                v-model="addjenisolga.logo_olga"
                                :rules="rules.files"
                                accept="image/png, image/jpeg, image/bmp"
                                placeholder="Pilih file"
                                prepend-icon="mdi-camera"
                                label="Logo"
                                show-size>
                              </v-file-input>
                            </v-col>
                          </v-row>
                          <v-row>
                            <v-col cols="12">
                              <v-btn
                                large
                                block
                                :disabled="!formadd.valid"
                                color="success"
                                class="mr-4 mt-5"
                                type="submit">
                                Simpan
                              </v-btn>
                            </v-col>
                          </v-row>
                        </v-col>
                      </v-row>
                    </v-form>
                  </v-container>
                </v-card-text>
              </v-card>
            </v-tab-item>
          </v-tabs-items>
        </v-card>
      </v-flex>
    </v-layout>
    <!-- modal - update -->
    <v-dialog
      v-model="dmodal.jenisolga"
      max-width="600px"
      v-if="dmodaldata.jenisolga">
      <v-card>
        <v-card-title>
          <span class="headline ma-auto">Update jenis olahraga</span>
        </v-card-title>
        <v-card-text>
          <v-container fluid grid-list-md class="pa-0">
            <v-form
              @submit.prevent="submitUpdate"
              ref="formupdatejenisolga"
              v-model="formupdate.valid"
              lazy-validation>
              <v-row justify="center" no-gutters>
                <v-col cols="12">
                  <v-row v-if="dmodaldata.jenisolga.logo_olga">
                    <v-col cols="12">
                      <div>
                        <v-img
                          max-width="100%"
                          width="150px"
                          class="ma-auto"
                          :src="dmodaldata.jenisolga.urlimg">
                        </v-img>
                      </div>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jenisolga.nama_olga"
                        :rules="[rules.required]"
                        label="Nama"
                        name="nama"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                        v-model="dmodaldata.jenisolga.deskripsi_olga"
                        :rules="[rules.required]"
                        label="Deskripsi jenis peolgaan"
                        name="deskripsi"
                        required>
                      </v-text-field>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="listfav"
                        name="favorite"
                        v-model="dmodaldata.jenisolga.favorite_olga"
                        label="Favorit">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-file-input
                        v-model="dmodaldata.jenisolga.logo_olganew"
                        accept="image/png, image/jpeg, image/bmp"
                        placeholder="Pilih file"
                        prepend-icon="mdi-camera"
                        label="Update Logo"
                        show-size>
                      </v-file-input>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        :items="liststatus"
                        name="statusolga"
                        v-model="dmodaldata.jenisolga.status_olga"
                        label="Status">
                      </v-select>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col cols="12" class="text-center">
                      <alertsp :alertdata="alertupdate"></alertsp>
                      <v-btn
                        large
                        color="error"
                        class="mr-4 mt-5"
                        @click="closeDmodal('jenisolga')">
                        Cancel
                      </v-btn>
                      <v-btn
                        large
                        :disabled="!formupdate.valid"
                        color="success"
                        class="mr-4 mt-5"
                        type="submit">
                        Simpan
                      </v-btn>
                    </v-col>
                  </v-row>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import qs from 'qs';
import Alertsp from '../../components/Alert.vue';
import { mapState } from 'vuex';

export default {
  name: 'JenisolgaAdmin',
  data: () => ({
    alertdata: {
      show: false,
      type: 'warning',
      text: '',
    },
    alertupdate: {
      show: false,
      type: 'warning',
      text: '',
    },
    loading: {
      getdata: false,
    },
    api: process.env.VUE_APP_API,
    baseurl: process.env.VUE_APP_BASEURL,
    maincolor: process.env.VUE_APP_MAINCOLOR,
    liststatus: ['active', 'passive'],
    listfav: ['tidak', 'ya'],
    filter: {
      search: '',
    },
    headers: [
      { text: 'Nama', value: 'nama_olga' },
      { text: 'Deskripsi', value: 'deskripsi_olga' },
      { text: 'Favorit', value: 'favorite_olga' },
      { text: 'Status', value: 'status_olga' },
      { text: 'Actions', value: 'action', sortable: false, align: 'center' },
    ],
    datalist: [],
    addjenisolga: {
      nama_olga: '',
      deskripsi_olga: '',
      logo_olga: null,
      favorite_olga: '',
    },
    formadd: {
      password: false,
      valid: false,
    },
    formupdate: {
      valid: false,
    },
    rules: {
      required: (value) => !!value || 'Required.',
      minpass: (v) => v.length >= 8 || 'Min 8 characters',
      nik: (v) => v.length >= 16 || 'Min 16 characters',
      files: [
        (value) => !value || value.size < 500000 || 'File kurang dari 500 Kb!',
      ],
    },
    tabdata: null,
    dmodal: {
      jenisolga: false,
    },
    dmodaldata: {
      jenisolga: null,
    },
  }),
  created: () => ({
  }),
  computed: {
    ...mapState([
      'isAuth',
      'tokenpub',
      'tokenscr',
      'userrole',
    ]),
  },
  mounted() {
    this.getJenisolga();
  },
  filters: {
    dateToAge(value) {
      return value;
    },
  },
  methods: {
    getJenisolga() {
      this.loading.getdata = true;
      if (this.tokenscr) {
        this.axios
          .get(
            this.api + '/api/jenisolga/',
            {
              params: {
              },
              headers: {
                Authorization: 'bearer ' + this.tokenscr,
              },
            },
          )
          .then((res) => {
            if (res.status === 200) {
              const resdata = res.data;
              if (resdata.error === false) {
                this.datalist = resdata.data;
              }
            }
            this.loading.getdata = false;
          })
          .catch((error) => {
            console.log(error);
            this.loading.getdata = false;
          });
      }
    },
    submitAdd() {
      this.alertdata.show = false;
      if (this.$refs.formaddjenisolga.validate()) {
        if (this.tokenscr) {
          const dataadd = this.addjenisolga;
          const formData = new FormData();
          // file image
          formData.append('logo_olga', dataadd.logo_olga);
          // data olga
          formData.append('nama_olga', dataadd.nama_olga);
          formData.append('deskripsi_olga', dataadd.deskripsi_olga);
          formData.append('favorite_olga', dataadd.favorite_olga);
          this.axios
            .post(
              this.api + '/api/jenisolga/',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.$refs.formaddjenisolga.reset();
                  this.alertdata.show = true;
                  this.alertdata.type = 'success';
                  this.alertdata.text = 'Olahraga "' + resdata.data + '" berhasil ditambahkan!';
                  this.getJenisolga();
                } else {
                  this.alertdata.show = true;
                  this.alertdata.type = 'error';
                  this.alertdata.text = resdata.message;
                }
              } else {
                this.alertdata.show = true;
                this.alertdata.type = 'error';
                this.alertdata.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertdata.show = true;
              this.alertdata.type = 'error';
              this.alertdata.text = 'Internal services error!';
            });
        } else {
          this.alertdata.show = true;
          this.alertdata.type = 'error';
          this.alertdata.text = 'Invalid token!';
        }
      }
    },
    closeDmodal(type) {
      if (type === 'jenisolga') {
        this.dmodal.jenisolga = false;
      } else {
        this.dmodal.jenisolga = false;
      }
    },
    editJenisolga(item) {
      this.dmodal.jenisolga = true;
      item.urlimg = this.api + '/upload/logo/' + item.logo_olga;
      this.dmodaldata.jenisolga = JSON.parse(JSON.stringify(item));
    },
    submitUpdate() {
      this.alertupdate.show = false;
      if (this.$refs.formupdatejenisolga.validate()) {
        if (this.tokenscr) {
          const dataadd = this.dmodaldata.jenisolga;
          const formData = new FormData();
          // file
          formData.append('logo_olganew', dataadd.logo_olganew);
          // data
          formData.append('status_olga', dataadd.status_olga);
          formData.append('favorite_olga', dataadd.favorite_olga);
          formData.append('deskripsi_olga', dataadd.deskripsi_olga);
          formData.append('nama_olga', dataadd.nama_olga);
          formData.append('logo_olgaold', dataadd.logo_olga);
          formData.append('id_olga', dataadd.id_olga);
          this.axios
            .post(
              this.api + '/api/jenisolga/update',
              formData,
              {
                headers: {
                  'Content-Type': 'multipart/form-data',
                  'Authorization': 'bearer ' + this.tokenscr,
                },
              },
            )
            .then((res) => {
              if (res.status === 200) {
                const resdata = res.data;
                if (resdata.error === false) {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'success';
                  this.alertupdate.text = this.dmodaldata.jenisolga.nama_olga + '" berhasil diubah!';
                  this.getJenisolga();
                } else {
                  this.alertupdate.show = true;
                  this.alertupdate.type = 'error';
                  this.alertupdate.text = resdata.message;
                }
              } else {
                this.alertupdate.show = true;
                this.alertupdate.type = 'error';
                this.alertupdate.text = 'Internal services error!';
              }
            })
            .catch((error) => {
              this.alertupdate.show = true;
              this.alertupdate.type = 'error';
              this.alertupdate.text = 'Internal services error!';
            });
        } else {
          this.alertupdate.show = true;
          this.alertupdate.type = 'error';
          this.alertupdate.text = 'Invalid token!';
        }
      }
    },
  },
  components: {
    Alertsp,
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
